import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = {
  state: {
    version: '1.0.0',
    user: {
      name: '',
      token: ''
    },
    searchParam: {
      from: '',
      key: ''
    },
    register: {
      name: ''
    },
    theme: '',
    // 登录dialog
    showLogin: false,
    // 无权限
    lackPermissions: false,
    // 是否申请试阅过
    isApplyRead: false,
    // 联系我们
    contactUs: false,
    // 关闭试阅
    isCloseRead: false,
    // readFailVisible: true,
    // 注册dialog
    accountVisible: false,
    // 忘记密码dialog
    forgotPassVisible: false,
    // 系统时间
    systemTime: '',
    // 时间备注
    timeRemark: '(GMT+8)'
  },
  getters: {},
  mutations: {
    login(state, value) {
      state.user = value;
    },
    logout(state) {
      state.user.token = '';
    },
    setTheme(state, value) {
      state.theme = value;
    },
    setSystemTime(state, value) {
      state.systemTime = value;
    },
    showLogin(state, value) {
      state.showLogin = value;
    },
    search(state, value) {
      state.searchParam.from = value.from;
      state.searchParam.key = value.tagNames;
    },
    readFailVisible(state, value) {
      state.lackPermissions = value
    },
    commitIsApplyRead(state, value) {
      state.isApplyRead = value
    },
    commitContactUs(state, value) {
      state.contactUs = value
    },
    commitCloseRead(state, value) {
      state.isCloseRead = value
    },
    accountVisible(state, value) {
      state.accountVisible = value
    },
    commitRegister(state, value) {
      state.register.name = value
    },
    forgotPassVisible(state, value) {
      state.forgotPassVisible = value
    }
  },
  actions: {}
};
export default new Vuex.Store(store);



// WEBPACK FOOTER //
// ./src/store/index.js